<template>
  <div class="AIAssistantMenuItem d-flex flex-column">
    <div 
      class="AIAssistantMenuItem__title flex-shrink-0"
      :class="{ 'isOpened' : isOpened}"
      @click="toggleSummary" 
    >
      <span>{{ title }}</span>
      <app-material-icon
        :name="isOpened ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
        class="ml-auto"
        size="sm"
      />
    </div>
    <div
      v-if="isOpened"
      class="AIAssistantMenuItem__content flex-grow-1 overflow-y-auto"
      :class="{ 'AIAssistantMenuItem__content--desktop': !$vuetify.display.mobile }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AIAssistantMenuItem',
  props: {
    isOpened: {
      type: Boolean,
    },
    title: {
      type: String,
      required: true,
    },
  },
  methods: {
    toggleSummary () {
      this.$emit('toggle-menu-item', !this.isOpened)
    },
  },
})
</script>

<style scoped lang="scss">
.AIAssistantMenuItem {
  height: 100%;
  
  &__title {
    align-items: center;
    border-bottom: 1px solid rgb(var(--v-theme-grey-100));
    border-top: 1px solid rgb(var(--v-theme-grey-100));
    cursor: pointer;
    display: flex;
    font-size: 16px;
    font-weight: 700;
    justify-content: space-between;
    padding: 24px 24px 24px 16px;

    &:hover, &.isOpened {
      background-color: rgb(var(--v-theme-grey-25));
    }
  }
  
  &__content {
    min-height: 0; // Important pour permettre le scroll dans flexbox
  }

  &__content--desktop {
    max-width: var(--ai-assistant-sidebar-width, 340px);
  }
}
</style>